import React from 'react'
import DialogWrapper from '../../../../components/core-ui/DialogWrapper'
import { Autocomplete, Box, Button, FormControl, TextField, Typography } from '@mui/material'
import { textFieldStyle } from '../../components/CreateProcessTemplateDialog'
import { HTTP_METHOD } from '../../../../utility/constants'

const AddOutboundServerAction = ({
  setShowOutboundServerAction,
  setNewServerAction,
  newServerAction,
  activities,
  routes,
  addOutboundServerAction,
  showAddOutboundAction,
}) => {
  return (
    <DialogWrapper
      actions={null}
      open={showAddOutboundAction}
      onClose={() => setShowOutboundServerAction(false)}
    >
      <Typography variant="h6" style={{ marginTop: 16 }}>
        {newServerAction.id ? 'Edit' : 'Add'} Outbound Server Action
      </Typography>
      <Box>
        <FormControl
          size="small"
          variant="outlined"
          fullWidth
          color="primary"
          style={{ minWidth: 300, marginTop: 16 }}
        >
          <TextField
            sx={textFieldStyle}
            size="small"
            placeholder="Action Label"
            label="Action Label"
            value={newServerAction.label}
            onChange={(e) => setNewServerAction({ ...newServerAction, label: e.target.value })}
          />
        </FormControl>
        <FormControl
          variant="outlined"
          fullWidth
          size="small"
          color="primary"
          style={{ minWidth: 300, marginTop: 16 }}
        >
          <Autocomplete
            sx={textFieldStyle}
            id="select-derived-field"
            options={activities.sort((a, b) =>
              a.process_template_name.localeCompare(b.process_template_name)
            )}
            size="small"
            getOptionLabel={(item) =>
              item?.process_template_name + '/' + item?.activity_template_name
            }
            value={
              activities?.find((it) => it.id === newServerAction.trigger_activity_template_id) ||
              null
            }
            onChange={(_, v) =>
              setNewServerAction({
                ...newServerAction,
                trigger_activity_template_id: v?.id,
              })
            }
            renderInput={(params) => (
              <TextField {...params} variant="outlined" label="Select Activity" color="primary" />
            )}
          />
        </FormControl>
        <FormControl
          variant="outlined"
          fullWidth
          size="small"
          color="primary"
          style={{ minWidth: 300, marginTop: 16 }}
        >
          <Autocomplete
            sx={textFieldStyle}
            id="select-derived-field"
            options={routes?.filter(
              (it) => it.from_activity_template_id === newServerAction.trigger_activity_template_id
            )}
            size="small"
            getOptionLabel={(item) => item?.route_template_name}
            value={routes?.find((it) => it.id === newServerAction.trigger_route_template_id)}
            onChange={(_, v) =>
              setNewServerAction({
                ...newServerAction,
                trigger_route_template_id: v?.id,
              })
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Select Triggering Route"
                color="primary"
              />
            )}
          />
        </FormControl>
        <FormControl
          size="small"
          variant="outlined"
          fullWidth
          color="primary"
          style={{ minWidth: 300, marginTop: 16 }}
        >
          <TextField
            sx={textFieldStyle}
            size="small"
            placeholder="Endpoint"
            label="Endpoint"
            value={newServerAction.endpoint}
            onChange={(e) => setNewServerAction({ ...newServerAction, endpoint: e.target.value })}
          />
        </FormControl>
        <FormControl
          size="small"
          variant="outlined"
          fullWidth
          color="primary"
          style={{ minWidth: 300, marginTop: 16 }}
        >
          <Autocomplete
            size="small"
            sx={textFieldStyle}
            options={Object.keys(HTTP_METHOD).map((it) => ({
              value: it,
              label: it,
            }))}
            value={
              newServerAction.http_request_method
                ? {
                    value: newServerAction.http_request_method,
                    label: newServerAction.http_request_method,
                  }
                : null
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Select HTTP Method"
                color="primary"
              />
            )}
            onChange={(_, v) =>
              setNewServerAction({ ...newServerAction, http_request_method: v?.value })
            }
          ></Autocomplete>
        </FormControl>
        <FormControl
          size="small"
          variant="outlined"
          fullWidth
          color="primary"
          style={{ minWidth: 300, marginTop: 16 }}
        >
          <TextField
            sx={textFieldStyle}
            size="small"
            placeholder="Headers"
            label="Headers"
            value={newServerAction.headers}
            onChange={(e) => setNewServerAction({ ...newServerAction, headers: e.target.value })}
          />
        </FormControl>
        <FormControl
          size="small"
          variant="outlined"
          fullWidth
          color="primary"
          style={{ minWidth: 300, marginTop: 16 }}
        >
          <TextField
            type="number"
            sx={textFieldStyle}
            size="small"
            placeholder="Sequence"
            label="Sequence"
            value={newServerAction.sequence}
            onChange={(e) =>
              setNewServerAction({ ...newServerAction, sequence: Number(e.target.value) })
            }
          />
        </FormControl>
        <Box style={{ display: 'flex', justifyContent: 'flex-end', padding: '16px 0px', gap: 16 }}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => setShowOutboundServerAction(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => addOutboundServerAction(newServerAction)}
          >
            Add
          </Button>
        </Box>
      </Box>
    </DialogWrapper>
  )
}

export default AddOutboundServerAction
